// material
import { useTheme, alpha } from '@mui/material/styles';
import { GlobalStyles as GlobalThemeStyles } from '@mui/material';

// ----------------------------------------------------------------------
// V2 Modern Global Styles

const V2_PRIMARY = '#7635dc';

export default function GlobalStyles() {
  const theme = useTheme();

  return (
    <GlobalThemeStyles
      styles={{
        '*': {
          margin: 0,
          padding: 0,
          boxSizing: 'border-box'
        },
        html: {
          width: '100%',
          height: '100%',
          WebkitOverflowScrolling: 'touch'
        },
        body: {
          width: '100%',
          height: '100%',
          // V2: Subtle purple-tinted background
          backgroundColor: theme.palette.mode === 'light' ? '#f8f7fc' : theme.palette.background.default
        },
        '#root': {
          width: '100%',
          height: '100%'
        },
        input: {
          '&[type=number]': {
            MozAppearance: 'textfield',
            '&::-webkit-outer-spin-button': {
              margin: 0,
              WebkitAppearance: 'none'
            },
            '&::-webkit-inner-spin-button': {
              margin: 0,
              WebkitAppearance: 'none'
            }
          }
        },
        textarea: {
          '&::-webkit-input-placeholder': {
            color: theme.palette.text.disabled
          },
          '&::-moz-placeholder': {
            opacity: 1,
            color: theme.palette.text.disabled
          },
          '&:-ms-input-placeholder': {
            color: theme.palette.text.disabled
          },
          '&::placeholder': {
            color: theme.palette.text.disabled
          }
        },

        img: { display: 'block', maxWidth: '100%' },

        // V2: Custom Scrollbar
        '*::-webkit-scrollbar': {
          width: 8,
          height: 8
        },
        '*::-webkit-scrollbar-track': {
          background: alpha(V2_PRIMARY, 0.05),
          borderRadius: 4
        },
        '*::-webkit-scrollbar-thumb': {
          background: alpha(V2_PRIMARY, 0.2),
          borderRadius: 4,
          '&:hover': {
            background: alpha(V2_PRIMARY, 0.3)
          }
        },

        // V2: Selection color
        '::selection': {
          backgroundColor: alpha(V2_PRIMARY, 0.2),
          color: '#1e1b4b'
        },

        // Lazy Load Img
        '.blur-up': {
          WebkitFilter: 'blur(5px)',
          filter: 'blur(5px)',
          transition: 'filter 400ms, -webkit-filter 400ms'
        },
        '.blur-up.lazyloaded ': {
          WebkitFilter: 'blur(0)',
          filter: 'blur(0)'
        },

        // V2: Focus visible for accessibility
        '*:focus-visible': {
          outline: `2px solid ${V2_PRIMARY}`,
          outlineOffset: 2
        }
      }}
    />
  );
}
